import businessRequest from '../business-service';

const config = {
    // baseURL: 'http://10.40.53.87:16630/',
    // headers: {
    //     'Internal-Token' : '{"account":"15018735011"}'
    // }
}
const prefix = 'manager';

// 分页查询地图
interface GetMapType {
    name: string;
    pageNo: number;
    pageSize: number;
    projectId: string;
}
export function getMap(params: GetMapType) {
    return businessRequest.get(
        `${prefix}/v1/map/page`,
        {
            params,
            ...config,
        },
    );
}

// 创建地图
interface PostMapType {
    fictitiousMap: {
        name: string;
        projectId: string;
    }
}
export function postMap(data: PostMapType) {
    return businessRequest.put(
        `${prefix}/v1/map/saveMap`,
        data,
        {
            ...config,
        }
    );
}

// 更新地图
interface PutMapType {
    id: string;
    name: string;
}
export function putMap(data: PutMapType) {
    return businessRequest.post(
        `${prefix}/v1/map/editMap`,
        data,
        {
            ...config,
        }
    );
}

// 删除地图
interface DeleteMapType {
    mapId: string;
}
export function deleteMap(params: DeleteMapType) {
    return businessRequest.delete(
        `${prefix}/v1/map/deleteMap`,
        {
            params,
            ...config,
        }
    );
}

// 获取地图内容
interface GetMapDetailType {
    mapId: string;
}
export function getMapDetail(params: GetMapDetailType) {
    return businessRequest.get(
        `${prefix}/v1/map/findMapDetails`,
        {
            params,
            ...config,
        },
    );
}

interface PublishMapType {
    fictitiousMap: {
        id: string;
    }
    mapAliasList: {
        name: string;
        synonyms: string[];
    }
}
export function publishMap(data: PublishMapType) {
    return businessRequest.post(
        `${prefix}/v1/map/releaseMap`,
        data,
        {
            ...config,
        },
    );
}

interface SyncMapType {
    deviceId: string;
}
export function syncMap(data: SyncMapType) {
    return businessRequest.put(
        `${prefix}/v1/map/syncDeviceMapAction`,
        null,
        {
            params: data,
            ...config,
        },
    );
}

interface GetSyncMapResType {
    deviceId: string;
}
export function getSyncMapRes(params: GetSyncMapResType) {
    return businessRequest.get(
        `${prefix}/v1/map/getSyncDeviceMap`,
        {
            params,
            ...config,
        }
    ).then(d => d.data);
}
